import React from "react";
import CustomEmptyState from "../../../../ui/CustomEmptyState/CustomEmptyState";


const PermissionEmptyState = ({ noPermissions, noResults }) => {
  if (noPermissions) {
    return (
      <CustomEmptyState
        height={300}
        primary="No permissions have been created yet."
        secondary="Start by creating your first permission to control access in your system."
      />
    );
  }

  if (noResults) {
    return (
      <CustomEmptyState
        height={200}
        primary="No permissions match your search."
        secondary="Try a different search term or clear your search to see all permissions."
      />
    );
  }

  return null;
};

export default PermissionEmptyState;
